import type { TreatmentApproach } from '@/entities/session';

export const treatmentApproachesGroups = {
    your: 'Your Approaches',
    others: 'Other Approaches',
} as const;

export const treatmentApproachesGroupsOrder = [
    treatmentApproachesGroups.your,
    treatmentApproachesGroups.others,
];

export const treatmentApproachLabels = {
    AEDP: 'AEDP',
    ACT: 'ACT',
    ATTACHMENT_BASED: 'Attachment-Based Therapy',
    BOWEN_FAMILY: 'Bowen Family Therapy',
    CBT: 'CBT',
    CPT: 'CPT',
    CRAFT: 'CRAFT',
    CFT: 'CFT',
    CREATIVE: 'Creative Therapies',
    CULTURALLY_SENSITIVE: 'Culturally Sensitive Therapy',
    DBT: 'DBT',
    EFT: 'EFT',
    EXPERIENTIAL: 'Experiential Therapy',
    ERP: 'ERP',
    EMDR: 'EMDR',
    IMAGO: 'Imago Relationship Therapy',
    ISTDP: 'ISTDP',
    IFS: 'IFS',
    IPT: 'IPT',
    MBCT: 'MBCT',
    MI: 'MI',
    NARRATIVE: 'Narrative Therapy',
    PCIT: 'PCIT',
    PERSON_CENTERED: 'Person-Centered Therapy',
    PROLONGED_EXPOSURE: 'Prolonged Exposure Therapy',
    PSYCHODYNAMIC: 'Psychodynamic',
    REBT: 'REBT',
    SFBT: 'SFBT',
    SOMATIC: 'Somatic Therapy',
    SPIRITUAL: 'Spiritual Counseling',
    STRENGTH_BASED: 'Strength-Based Therapy',
    STRUCTURAL_FAMILY: 'Structural Family Therapy',
    GOTTMAN: 'The Gottman Method',
    TRAUMA_FOCUSED: 'Trauma-Focused Therapy',
} as const satisfies Record<TreatmentApproach, string>;

const treatmentApproachLongNames: Partial<Record<TreatmentApproach, string>> = {
    AEDP: 'Accelerated Experiential Dynamic Psychotherapy',
    ACT: 'Acceptance and Commitment Therapy',
    CBT: 'Cognitive Behavioral Therapy',
    CPT: 'Cognitive Processing Therapy',
    CRAFT: 'Community Reinforcement and Family Training',
    CFT: 'Compassion-Focused Therapy',
    DBT: 'Dialectical Behavior Therapy',
    EFT: 'Emotionally Focused Therapy',
    ERP: 'Exposure and Response Prevention',
    EMDR: 'Eye Movement Desensitization and Reprocessing',
    ISTDP: 'Intensive Short-Term Dynamic Psychotherapy',
    IFS: 'Internal Family Systems',
    IPT: 'Interpersonal Therapy',
    MBCT: 'Mindfulness-Based Cognitive Therapy',
    MI: 'Motivational Interviewing',
    PCIT: 'Parent-Child Interaction Therapy',
    REBT: 'Rational Emotive Behavior Therapy',
    SFBT: 'Solution-Focused Brief Therapy',
};

export const treatmentApproachesOptions = (
    Object.entries(treatmentApproachLabels) as [TreatmentApproach, string][]
).map(([value, label]) => {
    const longName = treatmentApproachLongNames[value];
    return {
        value,
        label,
        keywords: longName ? [longName] : undefined,
    };
});

export function getTreatmentApproachLabel(value: TreatmentApproach): string {
    return treatmentApproachLabels[value] ?? value;
}

export function getTreatmentApproachLabels(values: TreatmentApproach[]): string[] {
    return values.map(getTreatmentApproachLabel);
}
